import { useEffect } from "react";
export const usePageTitle = (title: string | null, noDefaultTitle: boolean = false) => {
    useEffect(() => {
        if(noDefaultTitle){
            if (title) {
                document.title = title;
            }
        }
        else{
            if (title) {
                document.title = title;
            } else {
                document.title = 'Learning Platform'
            }
        }
        
    }, [title, noDefaultTitle])
}